export enum LegendChartType {
  BAR = 'bar',
  LINE = 'line',
}

export type FormatterFn = (v: number) => string;

export type XAxisDataKey = 'name';
type LegendName = { [key in XAxisDataKey]: string };

export type SummaryValueKey = 'summaryValue';
export type SummaryValue = { [key in SummaryValueKey]?: number };

export type Legend = { value: string; color: string; type: LegendChartType };

export type Legends<LegendKey extends string = string> = { [key in Exclude<LegendKey, XAxisDataKey>]: Legend };

export type ChartData<LegendType extends Legends> = (LegendName &
  SummaryValue &
  Required<{ [key in keyof LegendType]: number }>)[];

export type OverrideChartStyles = {
  barSize?: number;
  barGap?: number;
  unstackedBarGap?: number;
  legendTopMargin?: number;
};
